export enum ShiftEnum {
  Days = 'Days',
  Mid = 'Evenings',
  Nights = 'Nights',
}
